// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-components-SideNavigation-styles--root--SVnj1 {
  position: relative;
  box-sizing: border-box;
  padding: 20px 10px 0;
  background-color: #fff;
  background-color: var(--mainBackground);
}

@media screen and (min-width: 768px) {

.src-components-SideNavigation-styles--root--SVnj1 {
    padding: 35px 18px;
    width: 61px;
    background-color: transparent;
}
  }

@media screen and (min-width: 1024px) {

.src-components-SideNavigation-styles--root--SVnj1 {
    padding-left: 25px;
    padding-right: 25px;
    width: 75px;
}
  }

@media screen and (min-width: 1280px) {

.src-components-SideNavigation-styles--root--SVnj1 {
    width: 325px;
}
  }

/* Фикс, чтобы топлайн не перекрывал сайд нав при скролле */

.src-components-SideNavigation-styles--sideNav--GHP1r {
  position: relative;
  animation-name: src-components-SideNavigation-styles--move-back--ir4xJ;
  animation-fill-mode: forwards;
}

.src-components-SideNavigation-styles--sideNav--GHP1r.src-components-SideNavigation-styles--mounted--pdUuM {
    animation-duration: 0.2s;
  }

.src-components-SideNavigation-styles--sideNav--GHP1r.src-components-SideNavigation-styles--sticky--NHFt1 {
    position: fixed;
    top: 0;
    animation-name: src-components-SideNavigation-styles--move-forward--jms8y;
  }

@media (prefers-reduced-motion) {

.src-components-SideNavigation-styles--sideNav--GHP1r.src-components-SideNavigation-styles--sticky--NHFt1 {
      animation: none;
  }
    }

@media (prefers-reduced-motion) {

.src-components-SideNavigation-styles--sideNav--GHP1r {
    animation: none;
}
  }

@keyframes src-components-SideNavigation-styles--move-forward--jms8y {
  from {
    top: 35px;
  }

  to {
    top: 75px;
  }
}

@keyframes src-components-SideNavigation-styles--move-back--ir4xJ {
  from {
    top: 35px;
  }

  to {
    top: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/components/SideNavigation/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAuC;EAAvC,uCAAuC;AAiBzC;;AAfE;;AANF;IAOI,kBAAkB;IAClB,WAAW;IACX,6BAA6B;AAYjC;EAXE;;AAEA;;AAZF;IAaI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AAMf;EALE;;AAEA;;AAlBF;IAmBI,YAAY;AAEhB;EADE;;AAGF,2DAA2D;;AAC3D;EACE,kBAAkB;EAClB,sEAAyB;EACzB,6BAA6B;AAmB/B;;AAjBE;IACE,wBAAwB;EAC1B;;AAEA;IACE,eAAe;IACf,MAAM;IACN,yEAA4B;EAK9B;;AAHE;;AALF;MAMI,eAAe;EAEnB;IADE;;AAGF;;AAnBF;IAoBI,eAAe;AAEnB;EADE;;AAGF;EACE;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,MAAM;EACR;AACF","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.root {\n  position: relative;\n  box-sizing: border-box;\n  padding: 20px 10px 0;\n  background-color: var(--mainBackground);\n\n  @media (--desktop) {\n    padding: 35px 18px;\n    width: 61px;\n    background-color: transparent;\n  }\n\n  @media (--desktop-l) {\n    padding-left: 25px;\n    padding-right: 25px;\n    width: 75px;\n  }\n\n  @media (--desktop-x) {\n    width: 325px;\n  }\n}\n\n/* Фикс, чтобы топлайн не перекрывал сайд нав при скролле */\n.sideNav {\n  position: relative;\n  animation-name: move-back;\n  animation-fill-mode: forwards;\n\n  &.mounted {\n    animation-duration: 0.2s;\n  }\n\n  &.sticky {\n    position: fixed;\n    top: 0;\n    animation-name: move-forward;\n\n    @media (prefers-reduced-motion) {\n      animation: none;\n    }\n  }\n\n  @media (prefers-reduced-motion) {\n    animation: none;\n  }\n}\n\n@keyframes move-forward {\n  from {\n    top: 35px;\n  }\n\n  to {\n    top: 75px;\n  }\n}\n\n@keyframes move-back {\n  from {\n    top: 35px;\n  }\n\n  to {\n    top: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `src-components-SideNavigation-styles--root--SVnj1`,
	"sideNav": `src-components-SideNavigation-styles--sideNav--GHP1r`,
	"moveBack": `src-components-SideNavigation-styles--move-back--ir4xJ`,
	"mounted": `src-components-SideNavigation-styles--mounted--pdUuM`,
	"sticky": `src-components-SideNavigation-styles--sticky--NHFt1`,
	"moveForward": `src-components-SideNavigation-styles--move-forward--jms8y`
};
module.exports = ___CSS_LOADER_EXPORT___;
